import request from '../../utils/request'

// 获取当前登录企业配置信息
export function getByLogin (params) {
  return request.get('/business/webParam/getByLogin', {params})
}

// 获取当前登录企业配置信息
export function getByLoginNew () {
  return request.get('/business/webParam/getByLoginNew')
}

// 更新企业配置信息
export function renew (data) {
    return request.post('/business/webParam/renew', data)
  }
// 更新企业配置信息
export function renewUpdate (data) {
    return request.post('/business/webParam/renewUpdate', data)
  }

export function getByLoginAnchor () {
  return request.get('/business/webParam/getByLoginAnchor')
}

export function renewAnchorUpdate (data) {
  return request.post('/business/webParam/renewAnchorUpdate', data)
}

export function updateAnchorPageVersion (data) {
  return request.post('/business/webParam/updateAnchorPageVersion', data)
}